import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";

export class CreateOmsReturnDeliveryDialogComponent implements IController {

  order: any;
  duplicatedFulfillmentLine: any;
  tabIndex: any;
  isWeightInTotal: any;
  onTabSelect: Function;
  onOrderChange: Function;

  public availableDays;
  public packagesSizes;
  public defaultItemSize;
  public spotDimensions;
  public pricePlanBundle: any;
  public spotWeight;
  public locationTypes: typeof LocationType = LocationType;

  constructor(private ordersService: OrdersService, private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private moment) {
  }

  $onInit() {
    this.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(this.order.accountId)
      .then((pricePlanBundle) => {
        this.pricePlanBundle = pricePlanBundle;
      })
    this._loadFulfillmentSettings(this.order.accountId, this.order.returnFulfillmentLine.programType, 'Delivery');
  }

  $onChanges(changes: angular.IOnChangesObject) {
  }

  changePricePlan(pricePlan) {
    if (!!pricePlan && _.get(this.order.returnFulfillmentLine, 'programType') !== _.get(pricePlan, 'type')) {
      this.order.returnFulfillmentLine.programName = pricePlan.name;
      this.order.itemLines = [];
      this.order.returnFulfillmentLine.itemIds = [];
      this._loadFulfillmentSettings(this.order.accountId, pricePlan.type, 'Delivery');
      this.onOrderChange({order: this.order});
    }
  }

  addPackage() {
    const defaultItemSizeItem = _.find(this.packagesSizes, (p) => {
      return p.itemSize === this.defaultItemSize;
    });
    if (defaultItemSizeItem) {
      this.defaultItemSize = angular.copy(_.get(defaultItemSizeItem, 'itemSize'));
    }

    const newItem = this.createItem(this.order.returnFulfillmentLine, defaultItemSizeItem);
    this.order.returnFulfillmentLine.itemIds.push(newItem.id);
    this.order.itemLines.push(newItem);
    this.onOrderChange({order: this.order});
  }

  onRemovePackage(itemId) {
    this.order.returnFulfillmentLine.itemIds = _.filter(this.order.returnFulfillmentLine.itemIds, id => {
      return id !== itemId
    });

    const fulfillmentLineItemIndex = _.findIndex(this.order.itemLines, (i: any) => {
      return i.id === itemId;
    })
    this.order.itemLines.splice(fulfillmentLineItemIndex, 1);
    this.onOrderChange({order: this.order});
  }

  onPackageChange(packageItem) {
    const packageItemIndex = _.findIndex(this.order.itemLines, (i: any) => {
      return i.id === packageItem.id;
    })
    this.order.itemLines[packageItemIndex] = packageItem;
    this.onOrderChange({order: this.order});
  }

  onOriginTaskDateChange(notBefore) {
    if (this.order.returnFulfillmentLine.destinationTask.notBefore < notBefore) {
      this.order.returnFulfillmentLine.destinationTask.notBefore = this.moment(notBefore).startOf('day').valueOf();
      this.order.returnFulfillmentLine.destinationTask.notAfter = this.moment(notBefore).endOf('day').valueOf();
      this.onOrderChange({order: this.order});
    }
  }

  onDestinationTaskDateChange(notBefore) {
    if (this.order.returnFulfillmentLine.pickupTask.notBefore > notBefore) {
      this.order.returnFulfillmentLine.pickupTask.notBefore = this.moment(notBefore).startOf('day').valueOf();
      this.order.returnFulfillmentLine.pickupTask.notAfter = this.moment(notBefore).endOf('day').valueOf();
      this.onOrderChange({order: this.order});
    }
  }

  private _loadFulfillmentSettings(accountId, programType, serviceType) {
    this.ordersService.getOrderSettings(accountId, serviceType, programType, undefined)
      .then((orderSettings) => {
        this.availableDays = _.get(orderSettings, 'availableDays', []);
        this.packagesSizes = orderSettings.itemSizeList;
        this.defaultItemSize = orderSettings.defaultItemSize;
        this.spotDimensions = orderSettings.spotDimensions;
        this.spotWeight = orderSettings.spotWeight;
      })
  }

  private createItem(fulfillmentLine, defaultItemSizeItem) {
    const itemId = 'line_' + fulfillmentLine.id + '_' + (fulfillmentLine?.itemIds ? fulfillmentLine.itemIds.length : '0');
    return {
      count: 1,
      id: itemId,
      barcode: null,
      type: _.get(defaultItemSizeItem, 'itemSize'),
      labels: _.get(defaultItemSizeItem, 'labels', []),
      dimensions: _.get(defaultItemSizeItem, 'dimensions', {}),
      weight: _.get(defaultItemSizeItem, 'weight'),
      totalWeight: this.isWeightInTotal ? _.get(defaultItemSizeItem, 'weight') : undefined,
    };
  }

}

angular
  .module('bringoz.admin.oms')
  .component('createOmsReturnDeliveryDialog', {
    bindings: {
      order: '<',
      duplicatedFulfillmentLine: '<',
      tabIndex: '<',
      isWeightInTotal: '<',
      onTabSelect: '&',
      onOrderChange: '&',
    },
    template: require('./create-oms-return-delivery-dialog.html').default,
    controller: CreateOmsReturnDeliveryDialogComponent
  });
